import {renderElement} from "../utils/common";
import {getTaskElementTemplate} from "./templates";
import {Api} from "../api/api";
import {AnswerType, TaskType} from "./types";
import showAll from "../showAll";
import customSelect from "../customSelect";

enum ListType {
  DEADLINE,
  NOT_DEADLINE
}

class QueueChangeTasks {
  private readonly addTasksButtons: NodeListOf<HTMLButtonElement>;
  private readonly changeTasksButtons: NodeListOf<HTMLButtonElement>;

  private userIdFetchedTasks: number[] = [];

  private backendApi = new Api();

  constructor() {
    this.addTasksButtons = document.querySelectorAll(`.js-add-tasks`);
    this.changeTasksButtons = document.querySelectorAll(`.js-change-tasks`);

    this.onAddTaskButtonClick = this.onAddTaskButtonClick.bind(this);
    this.onChangeTaskButtonClick = this.onChangeTaskButtonClick.bind(this);
  }

  init() {
    if (this.addTasksButtons.length && this.changeTasksButtons.length) {
      this.addTasksButtons.forEach((button) => button.addEventListener(`click`, this.onAddTaskButtonClick));
      this.changeTasksButtons.forEach((button) => button.addEventListener(`click`, this.onChangeTaskButtonClick));
    }
  }

  private pushUserIdToFetchedTasks(id: number) {
    this.userIdFetchedTasks.push(id);
  }

  private getTaskList(addTasksButton: HTMLButtonElement): HTMLElement | null | undefined {
    return addTasksButton.closest(`.queue__item`)
      ?.querySelector(`.js-no-deadline-tasks-list`);
  }

  private addTaskListShowMoreClass(taskLists: HTMLElement, id: number) {
    taskLists.closest(`.queue__content`)
      ?.classList
      .add(`js-show-all-${id}`);
  }

  private initShowMoreScript(id: number) {
    showAll({
      containerSelector: `.js-show-all-${id}`,
    });
  }

  private initPrioritySelectScript(id: number) {
    // @ts-ignore
    customSelect({
      selectSelector: `.js-priority-select-${id}`,
      openClass: `priority__modal--show`,
      isPrioritySelect: true,
    });
  }

  private initTaskModule(selector: string) {
    window.taskEmitter.emit(`task/addQueue`, selector);
  }

  private renderTasks(parent: HTMLElement, tasks: TaskType[], userId: number) {
    if (tasks.length) {
      tasks.forEach((task) => renderElement(parent, getTaskElementTemplate(task, userId)));
    }
  }

  private changeTaskList(type: ListType, buttonElement: HTMLButtonElement) {
    const parent = buttonElement.closest(`.queue__wrapper`)!;
    const deadlineList = parent.querySelector(`.js-deadline-tab`);
    const notDeadlineList = parent.querySelector(`.js-not-deadline-tab`);

    switch (type) {
      case ListType.DEADLINE:
        deadlineList?.classList.add(`queue__content--show`);
        notDeadlineList?.classList.remove(`queue__content--show`);
        break;
      case ListType.NOT_DEADLINE:
        deadlineList?.classList.remove(`queue__content--show`);
        notDeadlineList?.classList.add(`queue__content--show`);
        break;
    }
  }

  async onAddTaskButtonClick(evt: Event) {
    const self = evt.currentTarget! as HTMLButtonElement;
    const userId = +self.dataset.userId!;

    if (!this.userIdFetchedTasks.includes(userId)) {
      // const res: AnswerType = await this.backendApi.customQuery(`/data/queue.json?id=${userId}`, {});
      const res: AnswerType = await this.backendApi.customQuery(`/task/get-task-not-date?userId=${userId}`, {});

      if (res.status === 200) {
        this.pushUserIdToFetchedTasks(userId);

        const tasksList = this.getTaskList(self);

        if (tasksList) {
          this.renderTasks(tasksList, res.answer, userId);
          this.addTaskListShowMoreClass(tasksList, userId);
          this.initShowMoreScript(userId);
          this.initPrioritySelectScript(userId);
          this.changeTaskList(ListType.NOT_DEADLINE, self);
          this.initTaskModule(`.js-task-item-${userId}`);
        }
      }
    } else {
      this.changeTaskList(ListType.NOT_DEADLINE, self);
    }
  }

  onChangeTaskButtonClick(evt: Event) {
    const self = evt.currentTarget! as HTMLButtonElement;

    this.changeTaskList(ListType.DEADLINE, self);
  }
}

export {QueueChangeTasks};
